import React, { useEffect } from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import CalculatorTitle from "./components/CalculatorTitle";
import Feedback from "./components/Feedback";
import FirstPayDate from "./components/FirstPayDate";
import Info from "./components/Info";
import Installment from "./components/Installment";
import MainData from "./components/MainData";
import PaymentTable from "./components/PaymentTable";
import SaveButton from "./components/SaveButton";
import { messages } from "./messages";
import { useAppSelector } from "./store";
import { useAnalytics } from "./utils";

function App() {
  const lang = useAppSelector((state) => state.lang);
  useAnalytics();

  return (
    <IntlProvider
      messages={messages[lang]}
      locale={lang}
      defaultLocale="en"
      defaultRichTextElements={{
        br: () => <br />,
        ul: (chunks) => <ul>{chunks}</ul>,
        li: (chunks) => <li>{chunks}</li>,
      }}
    >
      <div className="container">
        <CalculatorTitle />
        <Info />
        <MainData />
        <Installment />
        <FirstPayDate />
        <PaymentTable />
        <SaveButton />
        <div className="row mt-3">
          <div className="col-12 text-center">
            V4.2 <FormattedMessage id="Footer.Updated" />: 2025.07.10.
          </div>
        </div>
        <Feedback />
      </div>
    </IntlProvider>
  );
}

export default App;
